import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IBranchInvoiceMatrix } from "./Table";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILogin } from "../../models/Login";


interface Iprops {
    singleData: IBranchInvoiceMatrix,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
}

interface IBranchInvoiceMatrixHistory {
    id?: number,
    was_Sales_Percentage?: number,
    sales_Percentage?: number,
    was_Recruiter_Percentage?: number,
    recruiter_Percentage?: number,
    user_Name?: string,
    updated_On?: Date,
}

export const History = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBranchInvoiceMatrixHistory>, loading: boolean });
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/getBrancIncPercentageHistory", "GET", null, `historyID=${props.singleData.id}`, props.toast);
        if (response) {
            const data: Array<IBranchInvoiceMatrixHistory> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Branches Share Percentage History</h5>
        </div>
    );

    const onHide = () => {
        props.hideDialog();
    }

    const fromDate = (rowData: IBranchInvoiceMatrixHistory) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy HH:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Branch Share Percentage Change History" modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="65vh"
                value={tableData.tableData}
                emptyMessage="No History found."
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="was_Sales_Percentage" header="Previous Sales Percentage" />
                <Column field="sales_Percentage" header="Current Sales Percentage" />
                <Column field="was_Recruiter_Percentage" header="Previous Recruiter Percentage" />
                <Column field="recruiter_Percentage" header="Current Recruiter Percentage" />
                <Column field="user_Name" header="Updated By" />
                {/* <Column field="updated_On" header="Updated On" body={(rowData: IBranchInvoiceMatrixHistory) => fromDate(rowData)} /> */}
                <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, 'dd/MM/yyyy', DateFormat) } />
            </DataTable>
        </Dialog>
    );
}